module.exports = __webpack_public_path__ + "static/img/no1-CAR.3302be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardPH/img/no1-CAR.png
// module id = U7ZV
// module chunks = 1